<div
  class="relative z-[1] overflow-hidden rounded-2xl bg-neutral-50 shadow-md"
  [ngClass]="configurableClasses()"
>
  <div class="flex flex-wrap justify-between bg-neutral-100">
    <div class="flex items-center gap-2 px-4">
      <ng-content select="[header-indicators]" />
    </div>
    <div class="flex">
      <ng-content select="[header-actions]" />
    </div>
  </div>
  <div class="grid w-full grid-cols-12 gap-4 px-4 py-2">
    <ng-content />
  </div>
</div>
